export default {
  survey: {
    restartSurvey: 'Iniciar una nueva encuesta',
    sendingSurvey: 'Enviando vuestra encuesta. Por favor, espere…',
    errorSending: 'Lo lamentamos, no hemos podido enviar vuestra encuesta. Por favor, compruebe vuestra  conectividad e inténtelo de nuevo.',
    retryBtnText: 'Volver a intentar',
    // TODO: Translate (PWA)
    sending: 'Not Implemented.',
    checkoutError: 'Not Implemented.',
    doneBtnText: 'Not Implemented.',
    uploadImage: 'Not Implemented.',
    submitFeedback: 'Enviar comentarios'
  }
};